'use client';
import { objectKeys } from '../object.js';
import { isFunction } from '../../guards/isFunction/isFunction.js';
import { isArray } from '../../array/array.js';

function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
/**
 * https://github.com/epoberezkin/fast-deep-equal
 *
 * Известные исключения:
 * - empty array and empty object are not equal - treated as equal
 * - pseudo array and equivalent array are not equal - treated as equal
 * - not equal date objects - treated as equal
 * - date and object are not equal - treated as equal
 * - not equal RegExp objects (different pattern) - treated as equal
 * - not equal RegExp objects (different flags) - treated as equal
 * - RegExp and object are not equal - treated as equal
 * */ var deepEqual = function(a, b) {
    if (a === b) {
        return true;
    }
    if ((typeof a === "undefined" ? "undefined" : _type_of(a)) !== (typeof b === "undefined" ? "undefined" : _type_of(b))) {
        return false;
    }
    if (isFunction(a) && a.toString() === b.toString()) {
        return true;
    }
    var length, i, keys;
    if (a && b && typeof a == "object") {
        if (isArray(a)) {
            length = a.length;
            if (length != b.length) {
                return false;
            }
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        keys = objectKeys(a);
        length = keys.length;
        if (length !== objectKeys(b).length) {
            return false;
        }
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
};

export { deepEqual };
